;(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery', '../version', '../widget'], factory)
  } else {
    // Browser globals
    factory(jQuery)
  }
})(function($) {
  return $.widget('custom.dropdown', {
    version: '1.0.0',
    options: {
      trigger: '.dropdown-trigger',
      menu: '.dropdown-menu',
      item: '.menu-item',
      showClass: 'dropdown--show',
    },

    _create: function() {
      this._on(this.element.first(this.options.trigger), {mouseenter: '_show'})
      this._on(this.element.first(this.options.trigger), {mouseleave: '_hide'})

      this._refresh()
    },
    _refresh: function() {
      //
    },
    _destroy: function() {
      //
    },

    // Custom functions
    _show: function() {
      this.element.addClass(this.options.showClass)
    },
    _hide: function() {
      this.element.removeClass(this.options.showClass)
    },
  })
})
